export default function unsetGrabCursor() {
  var swiper = this;

  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';

  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}